import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface PlanLimitModalProps {
  open: boolean;
  onClose: () => void;
  entity: string;
  current: number;
  max: number;
}

export function PlanLimitModal({ open, onClose, entity, current, max }: PlanLimitModalProps) {
  const navigate = useNavigate();

  const entityLabels: Record<string, string> = {
    agents: "agentes",
    skills: "skills",
    members: "membros",
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
            <AlertTriangle className="w-6 h-6 text-destructive" />
          </div>
          <DialogTitle className="text-center">Limite do plano atingido</DialogTitle>
          <DialogDescription className="text-center">
            Você já possui {current} de {max} {entityLabels[entity] ?? entity} permitidos no seu plano atual.
            Faça upgrade para desbloquear mais recursos.
          </DialogDescription>
        </DialogHeader>
        <div className="flex gap-3 mt-4">
          <Button variant="outline" className="flex-1" onClick={onClose}>
            Voltar
          </Button>
          <Button
            className="flex-1"
            onClick={() => {
              onClose();
              navigate("/billing");
            }}
          >
            Fazer Upgrade
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
